import { ApolloLink } from "@apollo/client"
import { setContext } from "@apollo/client/link/context"
import { getIsLocalHost } from "../lib/env"

const AUTH_TOKEN_KEY = "auth_token"

// Lets the GraphQL server reissue a stored token scoped to another school,
// including a deployed server reached from a local client.
export const developmentClientLink = setContext((_, { headers }) =>
  getIsLocalHost()
    ? { headers: { ...headers, "X-Pathwright-Development-Client": "1" } }
    : { headers }
)

// Store the token the server reissued for this school, or drop the stored
// token when it could not be reissued. The response already resolved for the
// request school, so this is quiet and the operation is not retried.
export const refreshedAuthTokenLink = new ApolloLink((operation, forward) =>
  forward(operation).map((result) => {
    const refreshedAuthToken = result.extensions?.refreshedAuthToken
    if (refreshedAuthToken === undefined) return result

    // An older request must not replace or clear a login completed meanwhile.
    const sentToken = operation
      .getContext()
      .headers?.authorization?.replace(/^(Bearer|Token) +/, "")
    if (sentToken !== localStorage.getItem(AUTH_TOKEN_KEY)) return result

    if (typeof refreshedAuthToken === "string") {
      localStorage.setItem(AUTH_TOKEN_KEY, refreshedAuthToken)
    } else if (refreshedAuthToken === null) {
      localStorage.removeItem(AUTH_TOKEN_KEY)
    }
    return result
  })
)
